// Koru 専用 application_id。backend の enum 追加 (Jambo-Server#33244) と
// settingdb の application 登録（stg/本番）が揃って初めて各環境で有効になる。
export const APPLICATION_ID = "106";

export const WEB_APPLICATION_NAME = "Koru";

/** アプリの言語。sina は国内専用のため ja 固定（旧 i18n.language の置き換え） */
export const APP_LANGUAGE = "ja";

/** レビュアー匿名化用のモノトーンシルエットアバター（public 配下の静的アセット） */
export const REVIEWER_AVATAR_PATH = "/reviewer-avatar.svg";

/** 画像取得失敗時のデフォルトアバター（public 配下の静的アセット） */
export const DEFAULT_AVATAR_PATH = "/default-avatar.jpeg";

/** ポイント説明ページのベースURL */
export const POINTS_HELP_BASE_URL = "https://web2.miu-app.com/price/aira";

const ALVION_BASE_URL =
  import.meta.env.VITE_ALVION_URL ?? "https://web2.miu-app.com";

/** 問い合わせページのベースURL */
export const CONTACT_BASE_URL = `${ALVION_BASE_URL}/support/precautions`;
